import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import FullScreenOverlay from '@bibliocommons/deprecated-base-full-screen-overlay';
import { ExpandableText } from '@bibliocommons/deprecated-expandable';
import { ugcVideoShape, userIdentityShape, bibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';

import { allowFreeText } from 'app/helpers/user';
import VideoUGCEditor from '../UGCEditors/VideoUGCEditor';
import VideoPlayback from '../VideoPlayback';

import DisplayHeading from '../DisplayHeading';
import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';
import './VideoDisplay.scss';

export default class VideoDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <VideoUGCEditor
          bib={this.props.bib}
          shelfItem={this.props.shelfItem}
          handleClose={this.closeEditor}
          existingVideo={this.props.video}
          videosTransactions={this.props.videosTransactions}
          shelfTransactions={this.props.shelfTransactions}
          videosActions={this.props.videosActions}
          shelfActions={this.props.shelfActions}
        />
      )
    );
  }

  renderActions() {
    const { owner, videosActions, videosTransactions, video, bib } = this.props;

    if (owner.get('loggedIn')) {
      const videoId = video.get('id');
      const metadataId = video.get('metadataId');
      const handleRemove = () => videosActions.removeVideo({ metadataId, videoId });
      const isRemoving = videosTransactions.getIn([metadataId, videoId, 'isRemoving'], false);
      const title = bib.getIn(['briefInfo', 'title']);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_video" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_video" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={allowFreeText(owner) ? this.openEditor : undefined}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <DisplayWrapper className="cp-ugc-video-display">
        <div className="description-block">
          <DisplayHeading>
            <FormattedMessage id="ugc_video_display_label" /> {this.props.video.get('title')}
          </DisplayHeading>
          <ExpandableText text={this.props.video.get('description') || ''} truncateCount={160} />
          {this.renderActions()}
        </div>
        <div className="video-block">
          <VideoPlayback src={this.props.video.get('url')} title={this.props.video.get('title')} />
        </div>
        <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderEditor()}
        </FullScreenOverlay>
      </DisplayWrapper>
    );
  }
}

VideoDisplay.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape.isRequired,
  video: ugcVideoShape.isRequired,
  owner: userIdentityShape.isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
